import { render, staticRenderFns } from "./Create.vue?vue&type=template&id=ecc39b98&scoped=true&"
import script from "./Create.vue?vue&type=script&lang=js&"
export * from "./Create.vue?vue&type=script&lang=js&"
import style0 from "./Create.vue?vue&type=style&index=0&id=ecc39b98&lang=less&scoped=true&"
import style1 from "./Create.vue?vue&type=style&index=1&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ecc39b98",
  null
  
)

export default component.exports